var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyConversion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#11C89B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37077_19367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37077_19367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1673 25.6284C14.8648 25.0656 14.6363 24.4845 14.4818 23.8852C14.3273 23.2857 14.25 22.6744 14.25 22.0514C14.25 19.8886 15.0026 18.0479 16.5078 16.5294C18.0129 15.0107 19.8437 14.2514 22 14.2514H22.7808L20.9308 12.4014L21.9845 11.3477L25.6385 15.0014L21.9845 18.6552L20.9308 17.6014L22.7808 15.7514H22C20.2628 15.7514 18.7868 16.3629 17.572 17.5859C16.3573 18.8091 15.75 20.2976 15.75 22.0514C15.75 22.4656 15.7952 22.8793 15.8855 23.2927C15.976 23.7062 16.1116 24.1097 16.2923 24.5034L15.1673 25.6284ZM22.0155 32.6552L18.3615 29.0014L22.0155 25.3477L23.0693 26.4014L21.2192 28.2514H22C23.7372 28.2514 25.2132 27.6399 26.428 26.4169C27.6427 25.1937 28.25 23.7052 28.25 21.9514C28.25 21.5372 28.2048 21.1235 28.1145 20.7102C28.024 20.2967 27.8884 19.8931 27.7078 19.4994L28.8328 18.3744C29.1353 18.9372 29.3637 19.5183 29.5182 20.1177C29.6727 20.7172 29.75 21.3284 29.75 21.9514C29.75 24.1142 28.9974 25.9549 27.4923 27.4734C25.9871 28.9921 24.1563 29.7514 22 29.7514H21.2192L23.0693 31.6014L22.0155 32.6552Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyConversion);
export default __webpack_public_path__ + "static/media/currencyConversion.8bac005a4c64f2f290e489f0324ff194.svg";
export { ForwardRef as ReactComponent };